/* @flow */
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  toggleButton: {
    height: 'min-content',
    minHeight: 'unset',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: 0,
    background: 'none',
    borderRadius: 0,
    outlineWidth: '0px !important',
  },
  toggleButtonContainer: {
    display: 'flex',
    alignContent: 'center',
  },
  profile: {
    borderBottom: ({ theme }: ThemeFunction) => `1px solid ${theme.textColor}`,
  },
};
